const LIMIT = 999;
const MAX_LENGTH = 3;

export default {
  props: ['quantity', 'index', 'parentIndex', 'action'],
  data() {
    return {
      value: 1,
      disabled: false,
    };
  },
  methods: {
    async increase() {
      if (this.value < LIMIT) {
        this.disabled = true;

        await this.$store.dispatch(this.action, {
          index: this.index,
          parentIndex: this.parentIndex,
          quantity: ++this.value,
        });
        this.disabled = false;
      }

      this.reloadProductTotal();
    },
    async decrease() {
      /*if (this.value === 1) {
        if (this.parentIndex >= 0) {
          this.deleteProduct();
        } else {
          this.deletePhoto();
        }
      } else if (this.value > 1) {*/
      if (this.value === 1 && this.parentIndex >= 0) {
        this.deleteProduct();
      } else if (this.parentIndex >= 0 && this.value > 0 || this.value > 0 && this.myOrder.quantity > 1) {
        this.disabled = true;

        await this.$store.dispatch(this.action, {
          index: this.index,
          parentIndex: this.parentIndex,
          quantity: --this.value,
        });
        this.disabled = false;
      }

      this.reloadProductTotal();
    },
    isNumber(value) {
      const num = value.replace(/ /g, '');

      if (num === '0') {
        value = '';
      } else if (num.length > MAX_LENGTH) {
        value = value.slice(0, MAX_LENGTH);
      } else {
        value = value.replace(/[^0-9]/g, '');
      }

      const result = value === '' ? 1 : parseInt(value);

      this.value = result;
      this.$store.dispatch(this.action,
          {index: this.index, parentIndex: this.parentIndex, quantity: result});
    },
    reloadProductTotal() {
      if (this.cart && this.cart.albums && this.index && this.parentIndex && this.cart.albums[this.parentIndex] && this.cart.albums[this.parentIndex].products && this.cart.albums[this.parentIndex].products[this.index] && this.cart.albums[this.parentIndex].products[this.index].total) {
        this.$emit('reload-product-total', {index: this.index, parentIndex: this.parentIndex, total: this.cart.albums[this.parentIndex].products[this.index].total});
      }
    },
    deletePhoto() {
      const order = this.myOrder;
      const condition = order.photos.length > 1;

      if (condition) {
        order.photos.splice(this.index, 1);
        order.quantity = Object.values(order.photos).
            reduce((previous, {quantity}) => previous + quantity, 0);

        this.$store.dispatch('SET_ORDER', order);
      }
    },
    deleteProduct() {
      this.$store.dispatch('DELETE_PRODUCT', {
        index: this.index,
        parentIndex: this.parentIndex
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.value = this.quantity;
    });
  },
};
